import { z } from 'zod'
import { t } from 'i18next'
import {
  KmSchema,
  SignalSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'

// Default constants
const DEFAULT_ZUGMELDESTELLE = {
  art: '' as const,
  name: ''
}

const DEFAULT_AUFTRAG_26_10 = {
  enabled: true,
  field_26_14_km: '',
  field_26_15: DEFAULT_ZUGMELDESTELLE,
  des_der: '' as const
}

const DEFAULT_AUFTRAG_26_11 = {
  enabled: false
}

const DEFAULT_AUFTRAG_26_12 = {
  enabled: false,
  field_26_13_signal: ''
}

const DEFAULT_BEFEHL_26_FORM = {
  auftrag_26_10: DEFAULT_AUFTRAG_26_10,
  auftrag_26_11: DEFAULT_AUFTRAG_26_11,
  auftrag_26_12: DEFAULT_AUFTRAG_26_12
}

// Schema definitions
const Auftrag26_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_26_10.enabled),
    field_26_14_km: KmSchema,
    field_26_15: ZugmeldestelleSchema,
    des_der: z.enum(['des', 'der', '']).default(DEFAULT_AUFTRAG_26_10.des_der)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_26_10))

const Auftrag26_11Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_26_11.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_26_11))

const Auftrag26_12Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_26_12.enabled),
    field_26_13_signal: SignalSchema.optional()
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_26_12))

// Base schema
const Befehl26FormSchemaBase = z
  .object({
    auftrag_26_10: Auftrag26_10Schema,
    auftrag_26_11: Auftrag26_11Schema,
    auftrag_26_12: Auftrag26_12Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_26_FORM))

export const Befehl26FormSchema = Befehl26FormSchemaBase

// Validation schema
export const createBefehl26FormValidationSchema = () =>
  Befehl26FormSchemaBase.refine(
    (data) => {
      // Either 26.11 or 26.12 must be selected
      return data.auftrag_26_11.enabled || data.auftrag_26_12.enabled
    },
    {
      message: t('ui-validation:befehl26.select_one')
    }
  )

export type Befehl26FormData = z.infer<typeof Befehl26FormSchemaBase>
